var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input",
      class: { control: true, "input--has-error": _vm.errors.has("nif") }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.nifData,
            expression: "nifData"
          },
          {
            name: "validate",
            rawName: "v-validate",
            value: {
              required: true,
              numeric: _vm.isNif,
              uniqueNif: _vm.isNifUnique
            },
            expression:
              "{required: true, numeric: isNif,uniqueNif: isNifUnique}"
          }
        ],
        staticClass: "input__line",
        attrs: {
          placeholder: _vm.placeholder,
          type: "number",
          name: "nif",
          id: "nif"
        },
        domProps: { value: _vm.nifData },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.nifData = $event.target.value
            },
            _vm.emitValue
          ]
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "input__error" }, [
        _vm._v(_vm._s(_vm.$i18n.t(_vm.errors.first("nif"))))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-211029ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-211029ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/inputs/nif/nif.html
// module id = null
// module chunks = 